import React from "react";
import { useAccountShops, activeShopOf } from "./accountShopsStore";
import { elakayAutoText as text } from "../pageInside/dataElakay";
import SelectableOptionGrid from "../pageInside/SelectableOptionGrid";
import "./ProductShopSelector.css";

// Multi-select tiles (same SelectableOptionGrid as the category picker): a
// selected shop is highlighted with a check, an unselected one stays plain.
// No native checkbox -- mdbreact's global mdb.css hides/blocks them.
export default function ProductShopSelector({ value, onChange, type = "seller" }) {
  const { data, status, error } = useAccountShops();
  const shops = (data?.shops || []).filter((s) => s.type === type);
  const active = activeShopOf(data, type) || shops[0] || null;
  const selected = (value || []).map(String);
  const toggle = (id) => onChange(selected.includes(id) ? selected.filter((s) => s !== id) : [...selected, id]);
  // "All shops" only selects the IDs of the owner's active shops -- the product is never copied.
  const allIds = shops.map((shop) => String(shop._id));
  const allSelected = allIds.length > 1 && allIds.every((id) => selected.includes(id));
  return <fieldset className="form-group border rounded p-3" aria-busy={status === "loading"}>
    <legend className="h6">{text("h_multishop_select", "Shop / Shops")}</legend>
    {allIds.length > 1 && <button type="button" className="btn btn-sm btn-outline-secondary mb-2" aria-pressed={allSelected} onClick={() => onChange(allSelected ? [] : allIds)}>
      {allSelected ? text("h_multishop_clear_all", "Clear selection") : text("h_multishop_all_shops", "All shops")}
    </button>}
    {shops.length > 0 && <SelectableOptionGrid
      className="product-shop-selector__grid"
      options={shops.map((shop) => ({ value: String(shop._id), label: shop.name }))}
      selectedValues={selected}
      onToggle={toggle}
    />}
    {!selected.length && active && <small className="text-muted d-block mt-2">{text("h_multishop_fallback", "No explicit selection: use current shop {name}", { name: active.name })}</small>}
    {error && <div role="alert">{text("h_multishop_load_error", "Unable to load your shops.")}</div>}
    {status === "ready" && !shops.length && <small className="text-muted d-block">{text("h_multishop_first_auto", "You have no shop yet: your first shop is created with this product (you can rename it in My Shops).")}</small>}
  </fieldset>;
}
